import { api } from "@/api"

export type Category = DeepReadonly<{
  id: string
  name: string
  parentCategoryId: string | null
  color: string | null
  path: string[]
  namePath: string
}>

export const retrieveCategory = async (
  categoryId: string
): Promise<Category> => {
  const response = await api.get<Category>(
    `/products/categories/${categoryId}`
  )
  return response.body
}
